import type {AdIntegrationKind, Event as PlayerEvent} from 'theoplayer';

/**
 * Used to narrow the Event<'aderror'> type to a more specific type that contains the error details.
 *
 * @privateRemarks
 * THEOplayer SDK does expose only a "general" Event<'aderror'> type in AdsEventMap, but we could see in runtime that
 * the AdError event payload contains more properties that we could use.
 */
export interface PlayerAdErrorEvent extends PlayerEvent<'aderror'> {
  errorCode: number;
  message: string;
  problemType: string;
  source: string;
}

/**
 * THEOplayer ad integrations that are client-side inserted (CSAI).
 *
 * When upgrading THEOplayer, cross-check against THEO's `AdIntegrationKind` union — any *new* client-side integration
 * value must be added here.
 * See: https://optiview.dolby.com/docs/theoplayer/v11/api-reference/web/types/AdIntegrationKind.html
 */
export const CSAI_INTEGRATIONS: readonly AdIntegrationKind[] = ['csai', 'freewheel', 'google-ima', 'spotx', 'theo'];
